import { fetchRequest } from "@providers/conect";

const verUserApi = async ( data ) => {
  try {
    const url = `userswp/view`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const validateSsoApi = async ( data ) => {
  try {
    const url = `userswp/validate-sso`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const logsStoreApi = async ( data ) => {
  try {
    const url = `agendawp/logs`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const storeApi = async ( data ) => {
  try {
    const url = `agendawp/store`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verUserApi, validateSsoApi, logsStoreApi, storeApi };
